import { Controller } from "@hotwired/stimulus"

// Diálogo "hay una versión nueva" (apps nativas bajo la última versión): se abre al cargar una vez por sesión del
// WebView; "Ahora no", ir a la tienda, el clic fuera o el cierre del sistema lo cierran y lo recuerdan.
// Doc: _docs/mobile/hotwire_native/app_version_gate.md
export default class extends Controller {
  static values = { key: { type: String, default: "appUpdateDismissed" } }

  connect() {
    this.beforeCache = () => this.element.remove() // el snapshot de Turbo no se lleva el diálogo
    document.addEventListener("turbo:before-cache", this.beforeCache)
    if (this.#dismissed()) this.element.remove()
    else if (!this.element.open) this.element.showModal()
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
  }

  dismiss() {
    this.#remember()
    if (this.element.open) this.element.close()
    this.element.remove()
  }

  // El clic fuera del panel llega al propio <dialog> (su ::backdrop)
  backdrop(event) {
    if (event.target === this.element) this.dismiss()
  }

  // close del <dialog>: Escape o el atrás del sistema
  closed() {
    this.#remember()
    this.element.remove()
  }

  #remember() {
    try { sessionStorage.setItem(this.keyValue, "1") } catch {}
  }

  #dismissed() {
    try { return sessionStorage.getItem(this.keyValue) === "1" } catch { return false }
  }
}
